export enum ValidationErrorNamespaceEnum {
  Street = 'Street',
  City = 'City',
  State = 'State',
  AppointmentArrivalTime = 'AppointmentArrivalTime'
}
